import { render } from "./PEManagement.vue?vue&type=template&id=5196857a&scoped=true"
import script from "./PEManagement.vue?vue&type=script&lang=js"
export * from "./PEManagement.vue?vue&type=script&lang=js"

import "./PEManagement.vue?vue&type=style&index=0&id=5196857a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5196857a"]])

export default __exports__